import axios from 'axios';
import React, { useState } from 'react';
import { Button, Form, message, Upload, UploadFile } from 'antd';
import { NamePath } from 'rc-field-form/lib/interface';
import { UploadOutlined } from '@ant-design/icons';

import { GetToken } from '../../../services/auth';
import { IAttachment } from 'models/attachment';

type UploadInputProps = {
  name: NamePath;
  label: string;
  value?: IAttachment[];
  required?: boolean;
  disabled?: boolean;
  onChange?: any;
  customReference?: Record<'agreementId', string>;
};

export function UploadInput(props: UploadInputProps) {
  const [fileList, setFileList] = useState<UploadFile[]>();

  const action = `${process.env.REACT_APP_BASE_URL}/attachments`;
  const headers = {
    Authorization: `Bearer ${GetToken()}`,
  };

  const handleChange = (value: IAttachment[]) => {
    const newValue = { [props.name.toString()]: value };
    if (props.onChange) {
      props.onChange(newValue);
    }
  };

  return (
    <>
      <Form.Item
        name={props.name}
        label={props.label}
        rules={[{ required: props.required, message: `${props.label} is required` }]}
        valuePropName="fileList"
        normalize={(value) => {
          return value?.fileList.map((i: any) => {
            return i.response || i;
          });
        }}
      >
        <Upload
          fileList={fileList}
          action={action}
          disabled={props.disabled}
          headers={headers}
          customRequest={({ action, file, filename, headers, onError, onProgress, onSuccess, withCredentials }) => {
            const formData = new FormData();
            formData.append(filename!, file);
            if (props.customReference) {
              formData.append('agreementId', props.customReference.agreementId);
            }
            axios
              .post(action, formData, {
                withCredentials,
                headers,
                onUploadProgress: ({ total, loaded }) => {
                  if (onProgress) {
                    onProgress({ percent: Math.round((loaded / total) * 100) });
                  }
                },
              })
              .then(({ data: response }) => {
                if (onSuccess) {
                  onSuccess(response);
                }
              })
              .catch(onError);
            return {
              abort() {
                console.log('Upload progress was aborted.');
              },
            };
          }}
          onChange={(info) => {
            const value = info.fileList.slice();
            setFileList(value); // https://github.com/ant-design/ant-design/issues/2423
            if (info.file.status === 'done') {
              message.success(`${info.file.name} file uploaded successfully`);
            } else if (info.file.status === 'error') {
              message.error(`${info.file.name} file upload failed.`);
            }
            // Only notify when something was uploaded or removed
            if (info.file.status === 'done' || info.file.status === 'removed') {
              handleChange(value as unknown as IAttachment[]);
            }
          }}
        >
          <Button disabled={props.disabled}>
            <UploadOutlined />
            Click to upload
          </Button>
        </Upload>
      </Form.Item>
    </>
  );
}
